var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudentCheckboxChecked({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    fill: "#612680"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.85941 3.14059C9.04686 3.32804 9.04686 3.63196 8.85941 3.81941L4.37941 8.29941C4.19196 8.48686 3.88804 8.48686 3.70059 8.29941L1.14059 5.73941C0.953137 5.55196 0.953137 5.24804 1.14059 5.06059C1.32804 4.87314 1.63196 4.87314 1.81941 5.06059L4.04 7.28118L8.18059 3.14059C8.36804 2.95314 8.67196 2.95314 8.85941 3.14059Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentCheckboxChecked);
export default __webpack_public_path__ + "static/media/studentCheckboxChecked.604e9db16f55ea6d3e458cc484cd5c00.svg";
export { ForwardRef as ReactComponent };